const imageElement = document.getElementById('home-hero');

const toTopBtn = document.getElementById('to-top');
const observer = new IntersectionObserver((entries) => {
  if (!entries[0].isIntersecting) {
    toTopBtn.classList.add('show');
  } else {
    toTopBtn.classList.remove('show');
  }
});
observer.observe(imageElement);
